export default __webpack_public_path__ + "src/assets/icn-send.cc35cf7afe2c847be380deda80c6724d.svg";